import { LoadableBackground } from '@confluence/loadable';

export const QuickReload = LoadableBackground({
	loader: async () => {
		const { QuickReload } = await import(
			/* webpackChunkName: "loadable-QuickReload" */ '../src/QuickReload.tsx'
		);
		return QuickReload;
	},
});
